const t = "_wrapper_33vyv_1", n = "_sectionWrapper_33vyv_12", o = "_topSection_33vyv_16", a = "_stationNameWrapper_33vyv_20", e = "_stationName_33vyv_20", r = "_stationIcons_33vyv_32", s = "_adressAndDistance_33vyv_38", p = "_buttonWrapper_33vyv_46", _ = "_button_33vyv_46", c = "_trailerRentalButton_33vyv_61", i = "_openingHours_33vyv_64", v = "_mapWrapper_33vyv_77", u = {
  wrapper: t,
  sectionWrapper: n,
  topSection: o,
  stationNameWrapper: a,
  stationName: e,
  stationIcons: r,
  adressAndDistance: s,
  buttonWrapper: p,
  button: _,
  trailerRentalButton: c,
  openingHours: i,
  mapWrapper: v
};
export {
  s as adressAndDistance,
  _ as button,
  p as buttonWrapper,
  u as default,
  v as mapWrapper,
  i as openingHours,
  n as sectionWrapper,
  r as stationIcons,
  e as stationName,
  a as stationNameWrapper,
  o as topSection,
  c as trailerRentalButton,
  t as wrapper
};
